import { GraduationCap, Send, Award } from 'lucide-react';
import { useCustom } from '@refinedev/core';
import { Card, CardContent } from '@/components/ui/card';
import { resolveApiUrl } from '@/providers/api-url';

const API_URL = resolveApiUrl();

interface EntitlementsSummaryProps {
  coursesCount: number;
  channelsCount: number;
  userId: number;
}

interface SummaryCardProps {
  icon: React.ReactNode;
  label: string;
  count: number;
}

interface BonusesMeta {
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
}

interface BonusesApiResponse {
  success: boolean;
  data: unknown[];
  errors: null;
  meta: BonusesMeta | null;
}

function SummaryCard({ icon, label, count }: SummaryCardProps) {
  return (
    <Card>
      <CardContent className="flex flex-col items-center gap-2 p-4">
        <div className="text-muted-foreground">{icon}</div>
        <div className="text-2xl font-bold">{count}</div>
        <div className="text-muted-foreground text-xs">{label}</div>
      </CardContent>
    </Card>
  );
}

export function EntitlementsSummary({
  coursesCount,
  channelsCount,
  userId,
}: EntitlementsSummaryProps) {
  const bonusResult = useCustom<BonusesApiResponse>({
    url: `${API_URL}/user-bonuses/admin/users/${userId}/bonuses`,
    method: 'get',
    config: { query: { status: 'ACTIVE', limit: '1' } },
  });

  const bonusesCount = bonusResult.query.data?.data?.meta?.total ?? 0;

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
      <SummaryCard
        icon={<GraduationCap className="h-5 w-5" />}
        label="Курсы"
        count={coursesCount}
      />
      <SummaryCard icon={<Send className="h-5 w-5" />} label="Каналы" count={channelsCount} />
      <SummaryCard icon={<Award className="h-5 w-5" />} label="Привилегии" count={bonusesCount} />
    </div>
  );
}
